import Dialog from "../../atoms/dialog";
import { useState } from 'react'
import CreateTransaction from '../transactions/CreateTransaction';

export default function TransactionDialog(props) {

    const { onClose, view, rootId, onCompletion, title, children, forView, transactionDetails, setTransactionDetails, fetchTrasactionName} = props;
    const [open, setOpen] = useState(false);



    const handleClose = () => {
        setOpen(false);
        onClose()
    }

    return (
        <Dialog
            title={title || "Add Transaction"} 
            open={true}
            handleClose={handleClose}
            paperProps={{ style: { width: 1000, maxWidth: 1500 } }}
            container_id="create_transaction_alert"
        >
            {children || <CreateTransaction onClose={onClose} forView={forView} transactionDetails={transactionDetails} setTransactionDetails={setTransactionDetails} fetchTrasactionName={fetchTrasactionName}/>}
        </Dialog >
    )

}